import "./App.css";
import React from "react";
import { RouterProvider } from "react-router-dom";
import { createAppRouter } from "./app/routes/router";
import { store } from "./store";

const router = createAppRouter(store);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
